<template>
    <!-- 手机端筛选弹窗 -->
    <el-drawer custom-class="my-drawer" title="筛选" :visible.sync="drawer" direction="btt" :before-close="handleClose" size="60%" :wrapperClosable="false">
        <div class="main-content">
            <div>
                <div class="title">产品分类</div>
                <div class="item-select" :class="{ 'item-select-active': !form.productIdList.length }" @click="handleProductChange()">
                    全部
                </div>
                <div v-for="data in productList" class="item-select" :class="{ 'item-select-active': form.productIdList.includes(data.id) }" :key="data.id"
                    @click="handleProductChange(data.id)">
                    {{ data.name }}
                </div>
            </div>
            <div>
                <div class="title">拜访日期</div>
                <div class="filter-date-box">
                    <el-date-picker style="width: 100%" v-model="form.visitDayStart" type="date" placeholder="开始时间" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <span>-</span>
                    <el-date-picker style="width: 100%" v-model="form.visitDayEnd" type="date" placeholder="结束时间" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </div>
            </div>
        </div>
        <div class="footer-btn">
            <div class="button cancel" @click="handleClose">取消</div>
            <div class="button confirm" @click="confirm">确定</div>
        </div>
    </el-drawer>
</template>
<script>
import { mapState } from "vuex";

export default {
    name: 'filterLogsDrawer',
    props: {
        value: {
            type: Object,
            default: () => { },
        },
        drawer: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: {
                productIdList: [],
                visitDayStart: "",
                visitDayEnd: "",
            },
        };
    },
    watch: {
        drawer(val) {
            if (val) {
                this.form = this.$utils.deepCopy(this.value);
            }
        },
    },
    computed: {
        ...mapState(["productList"]),
    },
    methods: {
        confirm() {
            this.$emit("update:value", this.form);
            this.$emit("change", this.form);
            this.$emit("update:drawer", false);
        },
        handleClose() {
            this.$emit("update:drawer", false);
        },
        handleProductChange(val) {
            if (val === undefined) {
                // 点击全部
                this.form.productIdList = [];
            } else {
                let index = this.form.productIdList.indexOf(val);
                // 正选反选
                if (index == -1) {
                    this.form.productIdList.push(val);
                } else {
                    this.form.productIdList.splice(index, 1);
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.main-content {
    padding: 0 1.5rem 7rem;
    .title {
        font-size: 1.14rem;
        font-weight: 550;
        margin: 1rem 0;
    }
    .item-select {
        width: calc((100% / 2) - 0.5rem);
        text-align: center;
        display: inline-block;
        padding: 0.5rem 0.8rem;
        border-radius: 8px;
        color: #333333;
        background-color: rgba(0, 0, 0, 0.05);
        margin: 0 0.5rem 0.5rem 0;
    }
    .item-select-active {
        border: 1px solid $primary-btn-color;
        color: $primary-btn-color;
        background-color: rgba(4, 65, 144, 0.1);
    }
    .filter-date-box {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }
}
.footer-btn {
    padding: 10px 20px;
    background-color: #fff;
    position: absolute;
    bottom: 0;
    width: 100%;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    @include SAFE-BOTTOM-IOS;
    display: flex;
    .button {
        border-radius: 12px;
        border: none;
        padding: 0.86rem 0;
        font-size: 1.14rem;
        text-align: center;
    }
    .cancel {
        width: 25%;
        color: $primary-font-color;
        margin-right: 1rem;
        background-color: rgba(0, 0, 0, 0.08);
    }
    .confirm {
        flex: 1;
        background-color: $primary-btn-color;
        color: #fff;
    }
}
</style>
<style lang="scss">
.my-drawer {
    border-radius: 12px 12px 0 0;
    .el-drawer__header {
        text-align: center;
        color: $primary-font-color;
        font-weight: 550;
        font-size: 1.14rem;
        margin-bottom: 1rem;
        padding-left: 40px;
    }
}
</style>
